const state = {
  isShow: false,
  message: null,
};

const getters = {
  isShow: (state) => state.isShow,
  message: (state) => state.message,
};

const mutations = {
  /**
   * ダイアログを閉じる
   * @param {*} state
   */
  close(state) {
    state.isShow = false;
  },
  /**
   * ダイアログを表示する
   * @param {*} state
   */
  show(state, message) {
    state.isShow = true;
    state.message = message;
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
